var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPsbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 127,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#psb-logo_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.159 126.74L84.58 84.58H42.159V0L0 42.159v84.581h42.159z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.58 0L42.16 42.159h42.42v84.581l42.159-42.16V0H84.58z",
    fill: "#EA5616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.172 87.48c-14.756 0-23.188-10.804-23.188-24.242 0-10.803 6.061-24.24 22.661-24.24 10.276 0 17.127 6.323 19.498 9.221l13.438-13.438c-8.168-9.749-20.289-15.81-33.99-15.81-24.505 0-43.74 18.182-43.74 44.267 0 24.505 19.235 44.267 43.74 44.267 14.755 0 27.666-7.114 35.835-18.18l-13.439-13.439c-4.215 6.85-11.33 11.594-20.815 11.594zm80.892.263H365.2V70.88h16.864c5.269 0 10.539 2.108 10.539 8.431 0 6.324-5.27 8.432-10.539 8.432zm2.108-35.044H365.2V40.05h42.159V21.08h-64.292v84.581h42.159c16.863 0 29.511-8.432 29.511-26.35C415 61.131 402.089 52.7 384.172 52.7zM168.899 105.66h22.133V40.05h33.727v65.346h22.133V21.08h-77.993v84.581z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "psb-logo_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h415v126.74H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsbLogo);
export default __webpack_public_path__ + "static/media/psb-logo.1982299e419fa06bdc5233221a6fe881.svg";
export { ForwardRef as ReactComponent };